import React from "react";
import Loadable from "react-loadable";

const Loader = props => (
  <div>
    {props.error && (
      <div>
        Error! <button onClick={props.retry}>Retry</button>
      </div>
    )}
    {props.timedOut && (
      <div>
        Taking a long time... <button onClick={props.retry}>Retry</button>
      </div>
    )}
    {props.pastDelay && <div>Loading module {props.name} ...</div>}
  </div>
);

const loaderConf = {
  loading: Loader,
  delay: 200,
  timeout: 10000
};

const Cost = Loadable({
  loader: () => import(/* webpackChunkName: "cost" */ "../cost/Module"),
  ...loaderConf
});

const Mac = Loadable({
  loader: () => import(/* webpackChunkName: "mac" */ "../mac/Module"),
  ...loaderConf
});

const Lima = Loadable({
  loader: () => import( /* webpackChunkName: "lima" */ '../lima/Module'),
  ...loaderConf
});

const Medi = Loadable({
  loader: () => import( /* webpackChunkName: "lima" */ '../medi/Module'),
  ...loaderConf
});

const Bas = Loadable({
  loader: () => import(/* webpackChunkName: "bas" */ "../bas/Module"),
  ...loaderConf
});

const Mob = Loadable({
  loader: () => import(/* webpackChunkName: "mob" */ "../mob/Module"),
  ...loaderConf
});

const Spac = Loadable({
  loader: () => import(/* webpackChunkName: "spac" */ "../spac/Module"),
  ...loaderConf
});

const Adm = Loadable({
  loader: () => import(/* webpackChunkName: "adm" */ "../adm/Module"),
  ...loaderConf
});

const CambiarHora = Loadable({
  loader: () => import(/* webpackChunkName: "cambiar-hora" */ "../cambiar-hora/Module"),
  ...loaderConf
});

export default { Cost, Mac, Lima, Medi, Bas, Spac, Adm, CambiarHora, Mob };


